import { useCallback } from 'react';
import { createGlobalState } from 'react-use';

const initialState = {
	language: 'CHT',
	activeFloor: 0,
	selectedBooth: null,
	selectedExhibitor: null,
	selectedProduct: null,
	exhibitorSection: null,
	navigation: false,
};

const useAppState = createGlobalState(initialState);

const useApp = () => {
	const [appState, setAppState] = useAppState();

	const setCHT = useCallback(() => {
		setAppState({
			...appState,
			language: 'CHT',
		});
	}, [appState, setAppState]);

	const setENG = useCallback(() => {
		setAppState({
			...appState,
			language: 'ENG',
		});
	}, [appState, setAppState]);

	const setActiveFloor = useCallback((floor) => {
		setAppState((appState) => {
			return {
				...appState,
				activeFloor: floor,
			}
		});
	}, [setAppState]);

	const setSelectedBooth = useCallback((booth) => {
		setAppState((appState) => {
			return {
				...appState,
				selectedBooth: booth,
				navigation: false,
			}
		});
	}, [setAppState]);

	const setSelectedExhibitor = useCallback((exhibitor) => {
		setAppState((appState) => {
			return {
				...appState,
				selectedExhibitor: exhibitor,
			}
		});
	}, [setAppState]);

	const setFloorAndLang = useCallback((floor, lang) => {
		setAppState((appState) => {
			return {
				...appState,
				activeFloor: floor,
				language: lang,
			}
		});
	}, [setAppState]);

	const setLanguage = useCallback((lang) => {
		setAppState((appState) => {
			return {
				...appState,
				language: lang,
			}
		});
	}, [setAppState]);

	const setSelectedProduct = useCallback((product) => {
		setAppState((appState) => {
			return {
				...appState,
				selectedProduct: product,
			}
		});
	}, [setAppState]);

	const setExhibitorSection = useCallback((section) => {
		setAppState((appState) => {
			return {
				...appState,
				exhibitorSection: section,
			}
		});
	}, [setAppState]);

	const setNavigation = useCallback((navigation) => {
		setAppState((appState) => {
			return {
				...appState,
				navigation,
			}
		});
	}, [setAppState]);

	return { ...appState, setCHT, setENG, isCHT: appState.language === 'CHT', setActiveFloor, setSelectedBooth, setSelectedExhibitor, setFloorAndLang, setLanguage, setSelectedProduct, setExhibitorSection, setNavigation, setAppState };
}
export default useApp;